import { MediaHost } from "Constants/general";

export const shapeIconUrl = (file: unknown,
  base: string = process.env.REACT_APP_ICONS_URI || MediaHost || ""): string | undefined => {
  if (typeof file !== "string" || !file) return undefined;
  if (/^(https?:)?\/\//i.test(file)) return file;
  if (!base) return file;
  return `${base.replace(/\/$/, "")}/${file.replace(/^\//, "")}`;
};
